import { useSelector } from 'react-redux'
import { aiImageThunks } from 'store/features/aiImage/thunks'
import { aiImageSelectors } from 'store/features/aiImage/selectors'

import { AiContentLoading } from '../components/AiContentLoading'
import AiImageGenerateTabContent from './Content'
import AiImageGenerateFooter from './Footer'
import * as Styled from './styled'
import { dispatch } from 'store'
import { memo, useEffect, useMemo } from 'react'

const AiImageGenerateTab: React.FC = () => {
  const isModelsLoading = useSelector(aiImageSelectors.isModelsLoading)
  const models = useSelector(aiImageSelectors.models)
  const hasModels = !!models.data?.length
  const isLoading = useMemo(
    () => !hasModels || isModelsLoading,
    [hasModels, isModelsLoading]
  )

  useEffect(() => {
    if (!isModelsLoading && !hasModels) {
      dispatch(aiImageThunks.getModels())
    }
  }, [isModelsLoading, hasModels])

  return (
    <Styled.AiImageGenerateContainer>
      {isLoading ? (
        <AiContentLoading />
      ) : (
        <>
          <AiImageGenerateTabContent />
          <AiImageGenerateFooter />
        </>
      )}
    </Styled.AiImageGenerateContainer>
  )
}

export default memo(AiImageGenerateTab)
